<template>
  <div>

    <base-form :title="$route.params.id ? $t('roles.edit') : $t('roles.create')"
               @submit="createRole"
    >
      <fg-input :placeholder="$t('settings.roles.placeholder')"
                :error="getError($t('settings.roles.name'))"
                v-validate="modelValidations.roleName"
                :name="$t('settings.roles.name')"
                :label="$t('settings.roles.name')"
                :disabled="model.id"
                v-model="model.name">
      </fg-input>

      <fg-input :name="$t('roles.guard_name')"
                :label="$t('roles.guard_name')">
        <el-select v-model="model.guard_name"
                   :disabled="model.id"
                   :placeholder="$t('roles.guard_name')"
                   class="select-default">
          <el-option :label="$t('roles.guard_name.client')" value="api_client" class="select-default"/>
          <el-option :label="$t('roles.guard_name.user')" value="api_user" class="select-default"/>
        </el-select>
      </fg-input>
    </base-form>
    <div class="px-3">
      <section-separator size="lg" has-border class="mb-3">
        {{$t('generic.permissions')}}
      </section-separator>
      <data-table :data="permissions"
                  :entity="entity"
                  :is-loading="loadingPermissions"
                  :filters="[{key: 'match[guard_name]', value: this.model.guard_name}]"
                  :columns="columns"
                  :disable-permission-checks="true"
                  :go-to-details-on-row-click="false"
                  :show-pagination="false"
                  operations="refresh"
                  ref="table">
        <template v-slot:name="{row}">
          {{formatName(row.name)}}
        </template>
        <template v-slot:enabled="{row}">
          <base-switch :value="isPermissionEnabled(row)"
                       @input="onPermissionChange(row, $event)"/>
        </template>
      </data-table>
    </div>

  </div>
</template>
<script>
  import startCase from 'lodash/startCase'
  import camelCase from 'lodash/camelCase'
  import snakeCase from 'lodash/snakeCase'
  import PermissionService from 'src/services/PermissionService'
  import RoleService from 'src/services/RoleService'
  import { Select, Option } from 'element-ui'

  export default {
    name: 'settings-roles-edit',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data () {
      return {
        PermissionService,
        entity: 'permission',
        loading: false,
        loadingPermissions: false,
        permissions: [],
        model: {
          name: '',
          guard_name: 'api_user',
          permissions: []
        }
      }
    },
    computed: {
      modelValidations () {
        return {
          roleName: {
            required: true
          }
        }
      },
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('permissions.name'),
            minWidth: '140px'
          },
          {
            prop: 'enabled',
            label: this.$t('generic.enabled'),
            minWidth: '140px'
          }
        ]
      }

    },
    methods: {
      async validate () {
        return this.$validator.validateAll()
      },
      formatName (name) {
        return startCase(camelCase(name))
      },
      isPermissionEnabled (row) {
        return this.model.permissions.find(p => p.name === row.name) !== undefined
      },
      async onPermissionChange (row, value) {
        if (!this.model.id) {
          await this.createRole()
        }
        try {
          if (value) {
            await RoleService.attachPermission(this.model.id, {
              permissions: [row.name]
            })
            this.$notify({
              type: 'success',
              message: this.$t('permission.attach.success')
            })
          } else {
            await RoleService.detachPermission(this.model.id, {
              permissions: [row.name]
            })
            this.$notify({
              type: 'success',
              message: this.$t('permission.detach.success')
            })
          }
          await this.getRole()
        } catch (err) {
          this.$notify({
            type: 'danger',
            message: this.$t('permission.modify.error')
          })
        }
      },
      async createRole () {
        const valid = await this.validate()
        if (!valid) {
          return
        }
        try {
          this.loading = true
          const { data } = await RoleService.create({
            name: snakeCase(this.model.name),
            guard_name: this.model.guard_name,
          })
          await this.$router.push(`/settings/roles/${data.id}`)
          this.model.id = data.id
          await this.getPermissions()
        } catch (err) {
          if (err.handled) {
            return
          }
          this.$notify({
            type: 'danger',
            message: this.$t('roles.create.error')
          })
        } finally {
          this.loading = false
        }
      },
      async getRole () {
        if (!this.$route.params.id) {
          return
        }
        const {data} = await RoleService.getById(this.$route.params.id, {
          with: 'permissions'
        })
        this.model = {
          ...this.model,
          ...data
        }
        this.model.name = this.formatName(this.model.name)
      },
      async getPermissions () {
        try {
          this.loadingPermissions = true
          const {data} = await PermissionService.get()
          this.permissions = data.filter(p => p.guard_name === this.model.guard_name)
        } finally {
          this.loadingPermissions = false
        }
      }
    },
    async created () {
      this.loadingPermissions = true
      await this.getRole()
      await this.getPermissions()
    }
  }
</script>
<style>
</style>
